// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8116faca","111":"b87ce1d9","224":"d4c1434d","272":"fcda5f76","453":"359bce46","565":"f5282b70","692":"fc328bc6","795":"e4dc03c6","916":"8d20ae99"}[chunkId] + ".chunk.js";
};